import PropTypes from 'prop-types';
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { isRoleAllowed, readAuthFromStorage } from "../utils/auth";
import { canAccessAny, getUserPermissionsFromAuth, isStaffRole } from "../utils/userPermissions";

const ProtectedRoute = ({
  allowedRoles,
  requiredPermissions,
  requireStaff = false,
  requireAll = false,
}) => {
  const auth = useSelector((state) => state.auth);
  const storedAuth = readAuthFromStorage();

  const isAuthenticated = auth.isAuthenticated || storedAuth?.isAuthenticated;
  const role = auth.role || storedAuth?.role;
  const loading = auth.loading;
  const userPermissions = getUserPermissionsFromAuth(auth);

  if (loading && !isAuthenticated) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  if (requireStaff && !isStaffRole(role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (allowedRoles && !isRoleAllowed(role, allowedRoles)) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (requiredPermissions && requiredPermissions.length > 0) {
    const hasAccess = requireAll
      ? requiredPermissions.every((p) => userPermissions.includes(p))
      : canAccessAny(userPermissions, requiredPermissions);

    if (!hasAccess) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return <Outlet />;
};

ProtectedRoute.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
  requiredPermissions: PropTypes.arrayOf(PropTypes.string),
  requireStaff: PropTypes.bool,
  requireAll: PropTypes.bool,
};

export default ProtectedRoute;
